import COLORS from '@/constants/colors';

export default {
  wrapper: {
    background: '#FFFFFF',
    width: '100%',
    height: '62px',
    pr: '48px',
    pl: '18px',
    borderBottom: '1px solid #E5E9F2',
  },
  search: {
    width: '265px',
  },
  personIcon: {
    ml: 2.4,
    mt: 0.4,
  },

  popoverItem: {
    mt: 2.9,
    '& .MuiPopover-paper': {
      pointerEvents: 'auto',
    },
    pointerEvents: 'none',
  },

  popoverItemSelected: {
    borderRadius: '0px 0px 6px 6px',
    padding: '8px 16px',
    boxShadow:
      '0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 0px 0px 1px rgba(0, 0, 0, 0.05)',
    '&& .MuiSelected': {
      bgcolor: '#fff',
    },
    '& .MuiListItemButton-root.Mui-selected:hover': {
      PointerEvents: 'none',
      '&:hover': { backgroundColor: 'transparent' },
    },
  },

  popoverListItem: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'space-between',
  },

  popoverIcon: {
    pr: 1,
    pt: 0.5,
  },

  popoverText: {
    fontSize: '12px',
    color: COLORS.gray_3,
    fontWeight: 500,
    lineHeight: '20px',
  },
};
